import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import LandingPage from './pages/LandingPage/LandingPage';
import Header from './components/Header/Header';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="mainWrapper">
      <Header/>
      <LandingPage/>
    </div>
  </React.StrictMode>
);

reportWebVitals(console.log);
